module.exports = __webpack_public_path__ + "img/venus17.d63592e6.png";